import React from "react";
import { makeStyles, createStyles } from "@material-ui/styles";
import { Theme, Dialog } from "@material-ui/core";
import { DialogProps } from "@material-ui/core/Dialog";

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      padding: 0,
    },
    paper: {
      position: "relative",
      backgroundColor: theme.palette.common.white,
      borderRadius: 10,
      boxShadow: "0 5px 20px 0 rgba(0, 0, 0, 0.3)",
      overflowY: "visible",
      margin: 0,
      width: "100%",
      [theme.breakpoints.down("xs")]: {
        margin: "20px 0 0",
      },
    },
    paperWidthSm: {
      maxWidth: 328,
    },
    paperWidthMd: {
      maxWidth: 676,
    },
    paperWidthLg: {
      maxWidth: "90%",
    },
  });
});

const AphDialog: React.FC<DialogProps> = (props) => {
  const classes = useStyles({});

  return (
    <Dialog {...props} classes={classes}>
      {props.children}
    </Dialog>
  );
};

export default AphDialog;
